<div class="modal-header">
    <h4 class="modal-title header-5">
        Helio Assure Configuration
    </h4>
    <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="activeModal.dismiss('Cross click')"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        "
        alt="Close"
      />
    </button>
</div>

<div class="modal-body mt-2">
    @if(survey?.answers?.length) {
    <span class="accello-general-text10"> {{survey?.surveyTitle}} </span>
    <form class="mt-3">
        <div *ngFor="let item of survey?.answers; let i = index" class="card mb-3">
            <div class="d-flex align-items-center card-wrapper">
                <span class="flex-grow-1 " [ngClass]="item.answer === 'true' ? 'accello-general-text6': 'accello-general-text2'">{{
                    item.questionText
                    }}</span>
                <div>
                    <nz-switch [ngModel]="item.answer === 'true'"
                        (ngModelChange)="item.answer = $event ? 'true' : 'false'" name="selectAssets"></nz-switch>
                </div>
            </div>
        </div>
        <div class="d-flex m-auto justify-content-end mt-3">
            <button (click)="submitSurvey()" class="btn-accello-primary-light">
                <span>Config</span>
            </button>
        </div>
    </form>
    } @else {
        <app-loading class="h-100 loading-container" [text]="'Loading'"></app-loading>
    }
</div>